







import { Component, Vue } from 'vue-property-decorator';

import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ArrowBackIcon from '@/components/icons/ArrowBack.vue';

@Component({
  components: {
    GhostButton,
    ArrowBackIcon
  }
})
export default class BackButton extends Vue {
  get tPrefixButtons() {
    return 'common.buttons';
  }
}
